module.exports = __webpack_public_path__ + "img/microplastics-inspect-large.b276b3b3.png";